<template>
    <table-template actionUrl="/distributor/findDbtServiceRechargeMoneyRecords.action" ref="recharge-manager" :queryParams="queryParams">
        <template slot="search">

            <el-date-picker
                    clearable
                    style="margin-left: 10px;"
                    v-model="createTimeSearch"
                    @change="onCreateTimeChanged"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="创建时间开始"
                    end-placeholder="创建时间截止">
            </el-date-picker>
            <el-button style="margin-left: 10px;" type="primary" @click="$refs['recharge-manager'].search()">搜索</el-button>
        </template>
        <template slot="item">
            <el-table-column
                    prop="rechargeNumber"
                    label="订单号">
            </el-table-column>
            <el-table-column
                    label="充值时间">
                <template scope="scope">
                    {{scope.row.createTime | dateTimeFormat}}
                </template>
            </el-table-column>
            <el-table-column
                    label="充值金额（元）">
                <template scope="scope">
                    {{scope.row.rechargeMoney/100}}
                </template>
            </el-table-column>
        </template>
    </table-template>
</template>
<script>
import TableTemplate from '@/components/TableTemplate'
export default {
  name: 'other-cloud-service-recharge',
  data () {
    return {
      createTimeSearch: null,
      queryParams: {}
    }
  },
  components: { TableTemplate },
  methods: {
    onCreateTimeChanged (datetime) {
      if (!datetime || datetime[0] == null) {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
        this.$refs['recharge-manager'].search()
        return
      }
      this.queryParams.startTime = datetime[0].getTime()
      this.queryParams.endTime = datetime[1].getTime()
      this.$refs['recharge-manager'].search()
    }
  }
}
</script>
